// extracted by mini-css-extract-plugin
export default {"title":"SetUpPasswordForm_title__lbno8","form":"SetUpPasswordForm_form__Pgfk1","actions":"SetUpPasswordForm_actions__xKHjQ","submitButton":"SetUpPasswordForm_submitButton__3eCDk"};